import { defaultMeta } from '@/constants/defaultMeta';
import { parseDateRangeSearch } from '@/lib/parseDateRange';
import { sortBy } from '@/lib/sortBy';
import { useQuery } from '@/react-query/hooks/useQuery/useQuery';
import { groupQueries } from '@/services/groupsManagement/groupsManagement.queries';
import { useSearch } from '@tanstack/react-router';

export const useGroupsList = () => {
  const { sort, page, q, fetch, createdDate } = useSearch({
    from: '/(app)/configuration-management/group-management/',
  });
  const parsedCreatedDate = parseDateRangeSearch(createdDate, { start: 0, end: 0 });

  const { data, isLoading } = useQuery({
    ...groupQueries.list({
      row: page,
      search: q,
      fetch: fetch,
      fromDate: parsedCreatedDate?.start,
      toDate: parsedCreatedDate?.end,
    }),
    select: (res) => ({
      ...res,
      data: sortBy(res.data, sort),
    }),
  });

  return {
    groupsList: data?.data || [],
    isLoading,
    pagination: data?.meta?.pagination || defaultMeta,
  };
};
